export default class CompetencyCriteriaModel extends Backbone.Model {

    // TODO implement validation, defaults, etc.
}
